module.exports = __webpack_public_path__ + "static/wedding-ab58ecbf949706dd559cc6c66341c16f.jpg";